export default __webpack_public_path__ + "static/media/Thunder Sale.13f825bd.gif";